"use client"
// src/modules/footer/footer-newsletter.tsx
import Input from "@a24/form/Input";
import Label from "@a24/ui/Label";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useRef, useState } from "react";
import Icon from "@a24/ui/Icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var subscribeToMailchimp = (email) => fetch(
  "https://cherrylanetheatre.us3.list-manage.com/subscribe/post?u=1cc4dfceca56ee8fa5a6f1a0c&id=a0742e6e3d&f_id=00a0d9e3f0",
  {
    method: "POST",
    mode: "no-cors",
    body: new URLSearchParams({
      EMAIL: email,
      b_1cc4dfceca56ee8fa5a6f1a0c_a0742e6e3d: ""
    })
  }
);
var subscribeToKlaviyo = (email) => fetch(
  `https://a.klaviyo.com/client/subscriptions/?company_id=${process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY}`,
  {
    method: "POST",
    headers: { "Content-Type": "application/json", revision: "2025-04-15" },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Cherry Lane Theatre email capture",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
                properties: { is_via_cherry_lane: true }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: process.env.NEXT_PUBLIC_KLAVIYO_LIST_ID
            }
          }
        }
      }
    })
  }
);
var FooterNewsletter = ({
  labels = {
    newsletterInput: "Enter your email",
    newsletterLabel: "Newsletter Sign-Up",
    newsletterText: /* @__PURE__ */ jsxs(Fragment, { children: [
      "By entering your email you are consenting to receive emails from Cherry Lane Theatre & A24, and agree with our",
      " ",
      /* @__PURE__ */ jsx(
        Link,
        {
          href: "/terms-and-conditions",
          className: "underline",
          target: "_blank",
          children: "Terms & Conditions"
        }
      ),
      " ",
      "and",
      " ",
      /* @__PURE__ */ jsx(Link, { href: "/privacy-policy", className: "underline", target: "_blank", children: "Privacy Policy" }),
      "."
    ] })
  }
}) => {
  const ref = useRef(null);
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const router = useRouter();
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: "mc_embed_shell",
      className: "w-full max-w-100 sm:max-w-78 md:w-[26.25rem] relative mt-21 sm:mt-14 [@media(min-height:1024px)]:mt-[10.375rem]",
      children: /* @__PURE__ */ jsxs("div", { id: "mc_embed_signup", children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            text: labels.newsletterLabel,
            className: "text-heritage-off-white-full text-body-xs uppercase"
          }
        ),
        /* @__PURE__ */ jsx(
          "form",
          {
            id: "mc-embedded-subscribe-form",
            name: "mc-embedded-subscribe-form",
            className: "validate",
            onSubmit: async (e) => {
              e.preventDefault();
              setShowError(false);
              const email = ref.current?.value;
              const isValid = email?.match(
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
              );
              if (!isValid) {
                setShowError(true);
                return;
              }
              setIsSubmitting(true);
              await Promise.allSettled([
                subscribeToMailchimp(email),
                subscribeToKlaviyo(email)
              ]);
              router.push("/thank-you");
            },
            children: /* @__PURE__ */ jsxs("div", { id: "mc_embed_signup_scroll relative", children: [
              /* @__PURE__ */ jsx(
                Input,
                {
                  placeholder: labels.newsletterInput,
                  id: "mce-EMAIL",
                  name: "EMAIL",
                  innerWrapperClassName: "!border-t-0 !bg-transparent !border-l-0 !border-r-0 !border-b !rounded-none !border-heritage-off-white-80 hover:!border-heritage-off-white-80 !pl-0",
                  labelClassName: "!text-heritage-off-white-full text-label-base",
                  className: "mc-field-group !text-heritage-off-white-full body-lg pl-0 placeholder:text-heritage-off-white-full placeholder:opacity-48",
                  type: "email",
                  formNoValidate: true,
                  ref
                }
              ),
              /* @__PURE__ */ jsx("div", { className: "clear absolute top-[1em] right-0 flex items-center", children: /* @__PURE__ */ jsx(
                "button",
                {
                  type: "submit",
                  "aria-label": "subscribe",
                  id: "mc-embedded-subscribe",
                  className: "button-arrow-form h-full group",
                  disabled: isSubmitting,
                  children: /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "arrow-right",
                      SVGClassName: "w-[0.875rem] h-auto",
                      className: "group-hover:translate-x-1 transition-translate"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ jsx("div", { id: "mce-responses", className: "clear", children: showError && /* @__PURE__ */ jsx("div", { className: "response error-message", children: "Please enter a valid email address." }) })
            ] })
          }
        ),
        /* @__PURE__ */ jsx("p", { className: "mt-3 text-heritage-off-white-full text-body-sm", children: labels.newsletterText })
      ] })
    }
  );
};
var footer_newsletter_default = FooterNewsletter;

export {
  footer_newsletter_default
};
